/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_SubscriptionInputs */

const en_price_page_visit_subscription = /** @type {(inputs: Price_Page_Visit_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A subscription for ongoing coaching`)
};

const pl_price_page_visit_subscription = /** @type {(inputs: Price_Page_Visit_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonament na stałą współpracę`)
};

/**
* | output |
* | --- |
* | "A subscription for ongoing coaching" |
*
* @param {Price_Page_Visit_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_subscription = /** @type {((inputs?: Price_Page_Visit_SubscriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_SubscriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_subscription(inputs)
	return en_price_page_visit_subscription(inputs)
});